import { z } from 'zod';

import type { ZodUseQuery } from '@/utils/zodReactQuery';

export const alertSchema = z.object({
	id: z.number().int(),
	kind: z.string(),
	title: z.string(),
	conversationId: z.string().nullable(),
	occurredAt: z.string(),
	shadow: z.boolean(),
	deliveries: z.array(z.object({ sink: z.string(), status: z.string() })),
});

export const alertsResponse = z.object({ items: z.array(alertSchema) });

export type Alert = z.infer<typeof alertSchema>;
export type UseAlerts = ZodUseQuery<z.infer<typeof alertsResponse>, { days: number; limit: number }>;
